import { DEFAULT_THEME_COLOR } from '../../constants/theme';

export const FREAKS_DARK = '#121212';
export const FREAKS_GOLD = '#f5c542';
export const FREAKS_RED = '#e5484d';
export const FREAKS_TEXT = 'white';
export const FREAKS_MUTED = 'rgba(255,255,255,0.6)';

// shared by the game's tab sections (sx objects)
export const freaksSx = {
  card: {
    background: 'linear-gradient(135deg, rgba(13,27,42,0.9) 0%, rgba(9,20,32,0.9) 100%)',
    border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: 3,
    p: { xs: 1.5, sm: 2 },
    mb: 1.25,
    color: FREAKS_TEXT,
  },
  between: { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1.5 },
  row: { display: 'flex', alignItems: 'center' },
  grow: { flex: 1, minWidth: 0 },
  muted: { color: FREAKS_MUTED },
  small: { fontSize: 12 },
  bold: { fontWeight: 700 },
  title: { fontWeight: 700, fontSize: { xs: 16, sm: 17 } },
  sectionTitle: { fontWeight: 700, mt: 1.5, mb: 0.75, color: FREAKS_TEXT },
  intro: { color: FREAKS_MUTED, mb: 1.25, fontSize: 14 },
  empty: { textAlign: 'center', color: FREAKS_MUTED, my: 3 },
  bar: { height: 6, borderRadius: 3, backgroundColor: 'rgba(255,255,255,0.12)' },
};

// touch-friendly buttons (44px min height)
export const actionSx = (color = DEFAULT_THEME_COLOR) => ({
  minHeight: 44,
  borderRadius: 5,
  px: 2,
  flexShrink: 0,
  textTransform: 'none',
  fontWeight: 700,
  backgroundColor: color,
  color: 'white',
  '&:hover': { backgroundColor: color, filter: 'brightness(1.1)' },
  '&.Mui-disabled': { backgroundColor: 'rgba(255,255,255,0.12)', color: 'rgba(255,255,255,0.35)' },
});

export const tonalSx = {
  minHeight: 44,
  borderRadius: 5,
  px: 2,
  flexShrink: 0,
  textTransform: 'none',
  fontWeight: 700,
  backgroundColor: 'rgba(54,201,162,0.15)',
  color: DEFAULT_THEME_COLOR,
  '&:hover': { backgroundColor: 'rgba(54,201,162,0.25)' },
  '&.Mui-disabled': { backgroundColor: 'rgba(255,255,255,0.06)', color: 'rgba(255,255,255,0.3)' },
};

export const barSx = (color) => ({
  ...freaksSx.bar,
  '& .MuiLinearProgress-bar': { backgroundColor: color, borderRadius: 3 },
});
